import * as Immutable from 'immutable';
import { escapeRegExp } from 'lodash/fp';
import { propIn } from '../../../common/utils/immutableHelper';

export const TEMPLATE_TYPES = {
    BUILT_IN: 'BUILT_IN',
    CUSTOM: 'CUSTOM',
    EMPTY: 'EMPTY',
};

export const EMPTY_BOARD_TEMPLATE = Immutable.fromJS({
    id: null,
    displayName: 'Empty board',
    template: {
        id: null,
        templateBoardId: null,
        type: TEMPLATE_TYPES.EMPTY,
    },
});

export const getTemplateId = propIn(['id']);
export const getTemplateTitle = propIn(['title']);
export const getTemplateType = propIn(['type']);
export const getTemplateBoardId = propIn(['templateBoardId']);
export const getTemplateKeywords = propIn(['keywords']);

export const getTemplateEntryDisplayName = propIn(['displayName']);

export const getTemplateIsCustom = (template) => getTemplateType(template) === TEMPLATE_TYPES.CUSTOM;

const getTemplateSearchQueryFields = (template) =>
    [getTemplateTitle(template), getTemplateKeywords(template)].join(', ');

const getMatchScore = (queryRegex) => (string) => {
    if (!string) return -1;

    const match = string.match(queryRegex);
    if (!match) return -1;

    return match.index;
};

export const matchTemplate = (query) => {
    const queryRegex = new RegExp(escapeRegExp(query), 'i');

    return (template) => {
        const terms = getTemplateSearchQueryFields(template);

        return getMatchScore(queryRegex)(terms) > -1;
    };
};

export const sortMatchedTemplates = (query, defaultTemplates) => (templateA, templateB) => {
    const queryRegex = new RegExp(escapeRegExp(query), 'i');

    const defaultTemplateIds = defaultTemplates.map(getTemplateId);
    if (defaultTemplateIds.includes(getTemplateId(templateA))) return -1;
    if (defaultTemplateIds.includes(getTemplateId(templateB))) return 1;

    const templateAIndex = getMatchScore(queryRegex)(getTemplateSearchQueryFields(templateA));
    const templateBIndex = getMatchScore(queryRegex)(getTemplateSearchQueryFields(templateB));

    return templateAIndex - templateBIndex;
};
